import * as React from "react";
import { InternalLabelWrapper } from "./InternalLabelWrapper";
import { LabelWrapperProps } from "./LabelWrapperTypes";

export const LabelWrapper = (props: LabelWrapperProps): JSX.Element => (
  <InternalLabelWrapper {...props} />
);
